
export default {
  'download': {
    'documentTitle': 'Itinéraire ORS',
    'download': 'Télécharger',
    'downloadFileName': 'Nom du fichier a télécharger',
    'downloadFormat': 'Format du téléchargement',
    'downloadRoute': 'Télécharger l\'itinéraire',
    'preparingDownload': 'En train de préparer le téléchargement ...',
    'fileReady': 'Fichier prêt',
    'errorPreparingFile': 'Erreur lors de la préparation du fichier',
    'fileTooBigToBeDownloaded': 'Fichier trop gros pour être téléchargé',
    'standard': 'Standard'
  },
}
